export default __webpack_public_path__ + "05a47f9e469d408c629f931cd33ff8b2.woff2";